import { Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class TemplatesKeys extends MainKeys {
    public get place() {
        return Places.templates
    }
}

export default TemplatesKeys
